import React, {Component} from "react";
import Layout from "../components/layout/layout.jsx";
import "../sass/pages/contact.scss"
import SubmitWrapper from "../components/submitWrapper/submitWrapper";


const emailValid = (email) => /\S+@\S+\.\S+/.test(email);
const nameValid = (name) => /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/.test(name);



class Contact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isValid: {
                email: null,
                name: null,
                message: null
            },
            needsUpdate: false,
            lastField: null
        }
    }

    handleInput = (e) => {
        let {target} = e;
        let state;
        if (target.name === "_replyto") {
            state = {...this.state.isValid, ...{email: emailValid(target.value)}}
        }
        if (target.name === "name") {
            state = {...this.state.isValid, ...{name: nameValid(target.value)}}
        }
        if (target.name === "text-area") {
            state = {...this.state.isValid, ...{message: target.value.length > 0}}
        }
        if (state) {
            this.setState({
                isValid: state,
                lastField: target.name,
            })
        }
    }

    render() {
        return (
            <Layout
                title={"Contact"}
                name={"contact"}
                current={"contact"}
                keywords={"Staser, creative, contact"}
            >
                <div className="container">
                    <SubmitWrapper
                        state={this.state}
                        handleInput={this.handleInput}
                    />
                </div>
            </Layout>
        );
    }
}

export default Contact;
